import script from "./TgApp.vue?vue&type=script&setup=true&lang=js"
export * from "./TgApp.vue?vue&type=script&setup=true&lang=js"

import "./TgApp.vue?vue&type=style&index=0&id=f9591bf0&scoped=true&lang=css"

import exportComponent from "/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f9591bf0"]])

export default __exports__